import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../../shared/card';
import { useStylesMentorCard } from './styles';
import { MentorCardComponentProps } from './interface';
import MentorHeader from './mentor-header';
import MentorContent from './mentor-content';
import { EventType } from '../../../types';

const MentorCardComponent: React.FC<MentorCardComponentProps> = ({
  id,
  onClick,
  profileImage,
  name,
  education,
  description,
  languages,
  focusTopics,
  recommendedLabel,
  baseWidth,
  height,
  disabled,
  loading,
}) => {
  const classes = useStylesMentorCard({});
  const { t } = useTranslation();

  const sections = [
    {
      key: 'focusTopics',
      list: focusTopics,
      type: EventType.ONE_ON_ONE,
      title: t('v2.global.label_specialisedIn'),
      info: t('v2.global.label_canSupportOtherTopics'),
    },
    {
      key: 'languages',
      list: languages,
      title: t('v2.global.label_languages'),
    },
  ];

  return (
    <Card
      id={`cta_mentor_card_${id}`}
      type="mentor"
      baseWidth={baseWidth}
      height={height}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      header={
        <>
          {recommendedLabel && (
            <div className={classes.recommended}>{recommendedLabel}</div>
          )}
          <MentorHeader profileImage={profileImage} />
        </>
      }
      content={
        <MentorContent
          className={classes.content}
          sections={sections}
          {...{ name, education, description }}
        />
      }
      ctaLabel={t('v2.global.button_openProfile')}
    />
  );
};

export default MentorCardComponent;
